import axios from "axios";
import { useMutation } from "react-query";

interface Credentials {
  username: string;
  password: string;
}

const useAuthenticationTokenCreate = ({ onSuccess }: { onSuccess: (token: string) => void }) =>
  useMutation((credentials: Credentials) => axios.post<{ token: string }>("/api/authentication_token", credentials), {
    onSuccess: (response) => onSuccess(response.data.token),
  });

export { useAuthenticationTokenCreate };
